import React from "react";

import { CircularProgress, Backdrop, useTheme } from "@mui/material";
import { createStyles } from "@mui/material/styles";

const loaderStyles = createStyles((theme) => ({
    Backdrop: {
        //zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0,0,0,0.1)",
    },
}));

export default function Loader({ loading }) {
    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    const theme = useTheme()
    const classes = loaderStyles(theme);
    return (
        <Backdrop sx={classes.Backdrop} open={loading ? loading : true}>
            <CircularProgress />
        </Backdrop>
    );
}

